export const defaultParamsObj = {
  benchmark_list: [],
  contact_list: [],
  customer_list: [],
  start_date_list: [],
  end_date_list: [],
  asset_list: []
}

export const defaultParams = JSON.stringify(defaultParamsObj, null, "\t")
